/**
 * @module cex/router
 * @description Vue Router configuration for HEP Data Portal UI.
 */

const Module = () => import('./CexModule.vue');

import { useAuthStore } from '@/stores/authStore';

const filterPath = (to, from, next) => {
  if (to.fullPath !== to.path) {
    to.meta.breadcrumb = setBreadcrumbs(to, from);
    next({ path: to.path });
  } else {
    to.meta.breadcrumb = setBreadcrumbs(to, from);
    next();
  }
};

const setBreadcrumbs = (to) => {
  let breadcrumbs = [];
  const authStore = useAuthStore();

  if (authStore.user.isAdminUser && to.name === 'cexannualreport') {
      breadcrumbs.push({ label: 'Review Annual Reports', route: '/program/annualreports' });
      breadcrumbs.push({ label: to.meta.title });
  } else {
    breadcrumbs = to.meta.breadcrumb;
  }

  return breadcrumbs;
};

const moduleRoutes = {
  path: '/cex',
  component: Module,
  children: [
      {
          path: 'annualreport/:reportId',
          name: 'cexannualreport',
          props: true,
          meta: {
              title: 'Capital Expenditure Commitment Report',
              requiresAuth: true,
              breadcrumb: [
                  { label: 'Annual Reports', route: '/annualreports' },
                  { label: 'Capital Expenditure Committment Report' }
              ]
          },
          component: () => import('./views/CexReportView.vue'),
          beforeEnter: filterPath
      }
  ]
};

export default router => {
  router.addRoute(moduleRoutes);
};
